import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import LandingPage from "@/pages/LandingPage";
import ServicesPage from "@/pages/ServicesPage";
import ResourcesPage from "@/pages/ResourcesPage";
import EmbeddedFormPage from "@/pages/EmbeddedFormPage";
import { LanguageProvider } from "@/i18n/LanguageContext";

function App() {
  return (
    <div className="App">
      <LanguageProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<LandingPage />} />
            <Route path="/services" element={<ServicesPage />} />
            <Route path="/resources" element={<ResourcesPage />} />
            <Route path="/resources/client-authorisation" element={<EmbeddedFormPage formKey="client-authorisation" />} />
            <Route path="/resources/investment-property" element={<EmbeddedFormPage formKey="investment-property" />} />
            <Route path="/resources/individual-tax-return" element={<EmbeddedFormPage formKey="individual-tax-return" />} />
          </Routes>
        </BrowserRouter>
      </LanguageProvider>
      <Toaster
        theme="light"
        position="top-right"
        toastOptions={{
          style: {
            background: "#FFFFFF",
            border: "1px solid #E5E7EB",
            color: "#0B0F1A",
          },
        }}
      />
    </div>
  );
}

export default App;
